import { dispatch_clipboard_copy_success_event } from '@/lib/clipboard-copy-success-event';

export function copy_text_to_clipboard(text: string) {
  if (copy_text_with_temporary_textarea(text)) {
    dispatch_clipboard_copy_success_event(text);
    return;
  }

  void copy_text_with_clipboard_api(text);
}

function copy_text_with_temporary_textarea(text: string) {
  const active_element =
    document.activeElement instanceof HTMLElement ?
      document.activeElement
    : null;
  const text_area_element = document.createElement('textarea');

  try {
    text_area_element.value = text;
    text_area_element.readOnly = true;
    text_area_element.style.position = 'fixed';
    text_area_element.style.left = '-9999px';
    text_area_element.style.top = '0';
    document.body.appendChild(text_area_element);
    text_area_element.focus();
    text_area_element.select();

    return document.execCommand('copy');
  } catch (error) {
    console.error(
      `copy_text_with_temporary_textarea failed: text=${text}`,
      error,
    );

    return false;
  } finally {
    text_area_element.remove();
    active_element?.focus({ preventScroll: true });
  }
}

async function copy_text_with_clipboard_api(text: string) {
  try {
    await navigator.clipboard.writeText(text);
    dispatch_clipboard_copy_success_event(text);
  } catch (error) {
    console.error(`copy_text_with_clipboard_api failed: text=${text}`, error);
  }
}
